import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@mui/material";

export default function RentSuitDialog({ open, onClose, onSelect, suitList, suitReservations, newSuitReservation, suitSelectionService, dateRange }) {
  const [search, setSearch] = useState("");
  const [selectedSuit, setSelectedSuit] = useState(null);
  const [suit, setSuit] = useState(null);
  const [filteredSuits, setFilteredSuits] = useState([]);


  const handleSelect = (suit) => {
    setSelectedSuit(suit.suitID);
    setSuit(suit);
  };

  const filterAvailableSuits = (suitList) => {
    const firstFilter = suitList.filter(suit => {
      return !suitReservations.some(suitReservation => {
        const reservationStart = new Date(suitReservation.eventDateStart);
        const reservationEnd = new Date(suitReservation.eventDateEnd);
        const eventStart = new Date(dateRange.eventDateStart);
        const eventEnd = new Date(dateRange.eventDateEnd);

        const isSuitReserved = suitReservation.suitID === suit.suitID;
        const isSuit = suit.suitID > 3;

        const hasDateConflict = (eventStart >= reservationStart && eventStart <= reservationEnd) ||
          (eventEnd >= reservationStart && eventEnd <= reservationEnd) ||
          (eventStart <= reservationStart && eventEnd >= reservationEnd);

        return isSuitReserved && hasDateConflict || !isSuit;
      });
    });
    
    // Filtrar trajes ya seleccionados en newSuitReservation
    if (newSuitReservation && newSuitReservation.length > 0) {
      const secondFilter = firstFilter.filter(suit => {
        // Para newSuitReservation, solo excluir por suitID (trajes ya seleccionados)
        return !newSuitReservation.some(selectedSuit => 
          selectedSuit.suitID === suit.suitID
        );
      });
      return secondFilter;
    }
    return firstFilter;
  };

  const handleConfirm = () => {
    onSelect(suit);
  };

  useEffect(() => {
    console.log("New Suit Reservation:", newSuitReservation);

  }, [])

  useEffect(() => {
    if (suitList) {
      const suits = filterAvailableSuits(suitList);
      const filtered = suits.filter((suit) =>
        suit.suitName.toLowerCase().includes(search.toLowerCase()) ||
        (suit.code && suit.code.toLowerCase().includes(search.toLowerCase()))
      );
      console.log("Filtered Suits:", filtered);
      
      setFilteredSuits(filtered);
    }
  }, [suitList, search, suitReservations, newSuitReservation, dateRange]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Escoge el traje a alquilar</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Selecciona el traje que deseas rentar para este servicio.
        </DialogContentText>
        <TextField
          fullWidth
          margin="normal"
          label="Buscar traje"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Grid container spacing={2}>
          {filteredSuits.map((suit) => (
            (suit.suitName !== 'No aplica') &&
            <Grid item xs={12} sm={6} md={4} key={suit.suitID}>
              <Card
                onClick={() => handleSelect(suit)}
                sx={{
                  cursor: "pointer",
                  border:
                    selectedSuit === suit.suitID
                      ? "2px solid #f759ab"
                      : "1px solid #e0e0e0",
                  boxShadow:
                    selectedSuit === suit.suitID ? "0 4px 10px rgba(0,0,0,0.2)" : "none",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 8px 15px rgba(0,0,0,0.3)",
                  },
                }}
              >
                <CardContent sx={{ display: "flex", flexDirection: "column", height: 100 }}>
                  <Typography variant="h6">
                    {suit.suitName}
                  </Typography>
                  <div style={{ display: 'flex', flexDirection: "column", fontSize: '0.9rem', marginTop: '0.7rem' }}>
                    <Typography variant="h7">
                      Código: {suit.code}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={!selectedSuit}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}